import { IBaseStepHistory } from "models/StepHistoryDetail";

export interface IBillingPeriodData {
	id: number;
	documentNumber: string;
	documentType: string;
	documentAmount: number;
	allocatedAmount: number;
	remainingAmount: number;
	documentDate: string;
}

export interface IInvoiceUploadSummaryGridDetail {
	invoiceId: number;
	billingPeriod: string;
	poNumber: string;
	documentNumber: string;
	documentType: string;
	isConsiderInExpenditure: boolean;
	documentAmount: number;
	allocatedAmount: number;
	remainingAmount: number;
	documentDate: string;
	submittedBy: string;
	submittedDate: string;
	age: string;
	billingPeriodData: IBillingPeriodData[];
	phase: string;
	status: string;
	totalRows: number;
}

export class InvoiceUploadSummaryGridFilterModel {
	yearIds: string[] = [];
	billingPeriodIds: string[] = [];
	invoiceNumberIds: string[] = [];
	poNumberIds: string[] = [];
	invoiceAmount: string = "";
	submittedByIds: string[] = [];
	invoiceDate: Date | null = null;
	submittedDate: Date | null = null;
	ageIds: string[] = [];
	phaseIds: string[] = [];
	statusIds: string[] = [];
}

export interface ISupplierDocGridDetail {
	Description: string;
	Item: string;
	Qty: number;
	Vat: number;
	Price: number;
	NetPrice: number;
	vatAmount: number;
	lineTotal: number;
	totalRows: number;
}

export interface ISupplierDocFlyInGridDetail {
	code: string;
	description: string;
	qty: number;
	price: number;
	tax: string;
	netPrice: number;
	totalRows: number;
}

export interface IStatementGridDetail {
	date: string;
	description: string;
	reference: string;
	amount: number;
	dueDate: string;
	balance: number;
	totalRows: number;
}

export interface ISupplierDocStepHistory extends IBaseStepHistory {
	supplierDocStepId: number;
	stepStatusId: number;
	supplierDocId: number;
	stepStatus: string;
	sequenceNumber: number;
	cutOffTime: string;
	dateSubmitted: string;
	dateReviewed: string;
	dateCaptured: string;
	datePaid: string;
	cutOffDescription: string;
	cutOffColor?: string;
}

export class SupplierDocStepHistoryEmitter {
	supplierDocId: number = -1;
}
